import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import {hideModal, QBM_CRUD} from '../../../modules/modals'
import {currentSubjectSelector, handleCreateSubject, handleUpdateSubject, handleDeleteSubject, changeSubjectsEntities, deleteSubjectsEntities, setSubjectsCursor} from '../../../modules/subjects'
import {changeCategoriesEntities, deleteCategoriesEntities, handleCreateCategory, handleUpdateCategory, handleDeleteCategory, parentCategoriesSelector, currentCursorCategorySelector, setCategoryCheckedState, handleAfterCreationCheckedState, checkAndUploadCategories, setCategoriesCursor, uncheckCategories} from '../../../modules/categories'
import {currentSourceSelector, handleCreateSource, changeSourcesEntities, handleUpdateSource, handleDeleteSource, deleteSourcesEntities, checkAndUploadSources, clearSourcesCursor} from '../../../modules/sources'
import {tutorialModeSelector, setTutorialMode, handleStep_selectSubjectStep, handleStep_clickMultipleChoice} from '../../../modules/tutorial'
import { connect } from 'react-redux'
import { reduxForm, reset } from 'redux-form'
import Form from './Form.jsx'
import { checkAndUploadGeneralStatistic, checkAndUploadTemp, _uploadTrashed } from '../../../modules/questions'
import { QBM_NAV_CATEGORIES } from '../../../modules/app'

class QbmCrudModal extends Component {
    render() {
        let {zIndex} = this.props

        return (
            <Modal
                isOpen = {true}
                style = {{
                    overlay : {zIndex},
                }}
                onRequestClose={this.handleClose}
                overlayClassName = "custom-modal"
                className = "custom-modal-content create-dialog-modal-content"
            >
                <div className="create-dialog-modal-content__header">
                    {
                        this.getTitle()
                    }
                    <div
                        onClick={this.handleClose}
                        className="create-dialog-modal-content__close"
                    ></div>
                </div>
                <div className="create-dialog-modal-content__body">
                    {
                        this.getBody()
                    }
                </div>
            </Modal>
        )
    }

    handleClose = () => {
        const {hideModal, setTutorialMode, tutorialModeIsOn} = this.props
        this.massFormReset()
        hideModal({ modalType : QBM_CRUD})
        if (tutorialModeIsOn) {
            setTutorialMode(false)
        }
    }

    massFormReset = () => {
        const {resetForm} = this.props
        let formsForReset = ['createSubject', 'updateSubject', 'createCategory', 'updateCategory', 'createSource', 'updateSource']
        formsForReset.forEach(f => resetForm(f)())
    }

    getTitle = () => {
        const {qbmCrudAction, qbmEntity} = this.props
        const {formatMessage} = this.context
        const Title = this.Title
        let text
        switch (true) {
            case qbmEntity === "subject" : {
                if (qbmCrudAction === "create") {
                    text = "Add subject"
                } else if (qbmCrudAction === "update") {
                    text = "Edit subject"
                } else if (qbmCrudAction === "delete") {
                    text = "Delete subject"
                }
                break
            }
            case qbmEntity === "category" : {
                if (qbmCrudAction === "create") {
                    text = "Add category"
                } else if (qbmCrudAction === "update") {
                    text = "Edit category"
                } else if (qbmCrudAction === "delete") {
                    text = "Delete category"
                }
                break
            }
            case qbmEntity === "source" : {
                if (qbmCrudAction === "create") {
                    text = "Add source"
                } else if (qbmCrudAction === "update") {
                    text = "Edit source"
                } else if (qbmCrudAction === "delete") {
                    text = "Delete source"
                }
                break
            }
            default : {
                return null
                break
            }
        }

        return <Title>{formatMessage(text)}</Title>
    }
    getBody = () => {
        const {qbmCrudAction, qbmEntity, currentSubject = {}, parentCategories, currentCategory = {}, currentSource = {}, resetForm} = this.props
        const {id : subjectId, name : subjectName} = currentSubject
        const {id : categoryId, name : categoryName, parent_id : category_parent_id} = currentCategory
        const {id : sourceId, name : sourceName} = currentSource
        const {formatMessage} = this.context
        switch (true) {
            case qbmEntity === "subject" : {
                if (qbmCrudAction === "create") {
                    return (
                        <this.CreateSubjectForm
                            type = "create"
                            okButtonTxt = {`${formatMessage("Add more")}`}
                            successMessage = {`${formatMessage("Subject was created")}.`}
                            handleClose = {this.handleClose}
                            resetForm = {resetForm("createSubject")}
                        />
                    )
                } else if (qbmCrudAction === "update") {
                    return (
                        <this.UpdateSubjectForm
                            type = "update"
                            okButtonTxt = {`${formatMessage("Change")}`}
                            successMessage = {`${formatMessage("Subject was updated")}.`}
                            initialValues = {{id : subjectId, name : subjectName}}
                            handleClose = {this.handleClose}
                            resetForm = {resetForm("updateSubject")}
                        />
                    )
                } else if (qbmCrudAction === "delete") {
                    return (
                        <this.DeleteSubjectForm
                            type = "delete"
                            okButtonTxt = {`${formatMessage("Delete")}`}
                            successMessage = {`${formatMessage("Subject was deleted")}.`}
                            initialValues = {{id : subjectId}}
                            confirmText = {`${formatMessage("Do you want to delete the subject")}: ${subjectName}?`}
                            handleClose = {this.handleClose}
                        />
                    )
                }
                break
            }
            case qbmEntity === "category" : {
                if (qbmCrudAction === "create") {
                    return (
                        <this.CreateCategoryForm
                            type = "create"
                            okButtonTxt = {`${formatMessage("Add more")}`}
                            successMessage = {`${formatMessage(`Entity were created`)}.`}
                            handleClose = {this.handleClose}
                            initialValues = {{subjectId}}
                            qbmEntity = {qbmEntity}
                            categories = {parentCategories}
                            resetForm = {resetForm("createCategory")}
                        />
                    )
                } else if (qbmCrudAction === "update") {
                    return (
                        <this.UpdateCategoryForm
                            type = "update"
                            okButtonTxt = {`${formatMessage("Change")}`}
                            successMessage = {`${formatMessage(`${category_parent_id ? "Subcategory" : "Category"} was updated`)}.`}
                            initialValues = {{id : categoryId, name : categoryName, isSubcategory : !!category_parent_id, subjectId}}
                            handleClose = {this.handleClose}
                            resetForm = {resetForm("updateCategory")}
                        />
                    )
                } else if (qbmCrudAction === "delete") {
                    return (
                        <this.DeleteCategoryForm
                            type = "delete"
                            okButtonTxt = {`${formatMessage("Delete")}`}
                            successMessage = {`${formatMessage(`${category_parent_id ? "Subcategory" : "Category"} was deleted`)}.`}
                            initialValues = {{id : categoryId, isSubcategory : !!category_parent_id, subjectId}}
                            confirmText = {`${formatMessage(`Do you want to delete the ${category_parent_id ? "subcategory" : "category"}`)}: ${categoryName}?`}
                            handleClose = {this.handleClose}
                        />
                    )
                }
                break
            }
            case qbmEntity === "source" : {
                if (qbmCrudAction === "create") {
                    return (
                        <this.CreateSourceForm
                            type = "create"
                            okButtonTxt = {`${formatMessage("Add more")}`}
                            successMessage = {`${formatMessage("Source was created")}.`}
                            initialValues = {{subjectId}}
                            handleClose = {this.handleClose}
                            resetForm = {resetForm("createSource")}
                        />
                    )
                } else if (qbmCrudAction === "update") {
                    return (
                        <this.UpdateSourceForm
                            type = "update"
                            okButtonTxt = {`${formatMessage("Change")}`}
                            successMessage = {`${formatMessage("Source was updated")}.`}
                            initialValues = {{id : sourceId, name : sourceName, subjectId}}
                            handleClose = {this.handleClose}
                            resetForm = {resetForm("updateSource")}
                        />
                    )
                } else if (qbmCrudAction === "delete") {
                    return (
                        <this.DeleteSourceForm
                            type = "delete"
                            okButtonTxt = {`${formatMessage("Delete")}`}
                            successMessage = {`${formatMessage("Source was deleted")}.`}
                            initialValues = {{id : sourceId, subjectId}}
                            confirmText = {`${formatMessage("Do you want to delete the source")}: ${subjectName}?`}
                            handleClose = {this.handleClose}
                        />
                    )
                }
                break
                break
            }
            default : {
                return null
                break
            }
        }
    }
    CreateSubjectForm = reduxForm({
        form: 'createSubject',
        onSubmit : (values, dispatch) => {
            const {hideForm, name, setFocus} = values
            return handleCreateSubject({name})
                    .then(subject => {
                        dispatch(changeSubjectsEntities([subject]))
                        dispatch(reset("createSubject"))
                        if (hideForm) this.handleClose()
                        if (setFocus) setFocus()

                        const {tutorialModeIsOn, handleStep_selectSubjectStep} = this.props
                        if (tutorialModeIsOn) {
                            this.handleClose()
                            handleStep_selectSubjectStep()
                        }
                    })
        },
    })(Form)
    UpdateSubjectForm = reduxForm({
        form: 'updateSubject',
        onSubmit : (values, dispatch) => {
            const {id, name} = values
            return handleUpdateSubject({id, name})
                .then(subject => {
                    dispatch(changeSubjectsEntities([subject]))
                    dispatch(setSubjectsCursor(subject.id))
                    dispatch(checkAndUploadCategories(subject.id))
                    dispatch(checkAndUploadSources(subject.id))             
                    dispatch(checkAndUploadGeneralStatistic(true))
                    this.handleClose()
                })
        }
    })(Form)
    DeleteSubjectForm = reduxForm({
        form: 'deleteSubject',
        onSubmit : (values, dispatch) => {
            const {id} = values
            handleDeleteSubject({id})
                .then((deletedId) => {
                    dispatch(deleteSubjectsEntities([deletedId]))
                    dispatch(checkAndUploadGeneralStatistic(true))
                    dispatch(_uploadTrashed())
                    this.handleClose()
                })
        }
    })(Form)


    CreateCategoryForm = reduxForm({
        form: 'createCategory',
        onSubmit : (values, dispatch) => {
            const {hideForm, name, subjectId, parent, setFocus} = values
            const isSubcategory = !!parent
            return handleCreateCategory({name, isSubcategory, parent, subjectId})
                .then(category => {
                    dispatch(changeCategoriesEntities({categories : [category], subjectId}))
                    dispatch(reset("createCategory"))
                    if (hideForm) this.handleClose()
                    if (setFocus) setFocus()
                    dispatch(handleAfterCreationCheckedState({id : category.id}))

                    const {tutorialModeIsOn, handleStep_clickMultipleChoice} = this.props
                    if (tutorialModeIsOn) {
                        this.handleClose()
                        handleStep_clickMultipleChoice()
                    }
                })
        }
    })(Form)
    UpdateCategoryForm = reduxForm({
        form: 'updateCategory',
        onSubmit : (values, dispatch) => {
            const {id, name, isSubcategory, subjectId} = values
            return handleUpdateCategory({id, name, isSubcategory})
                .then(category => {
                    dispatch(changeCategoriesEntities({categories : [category], subjectId}))
                    this.handleClose()
                })
        }
    })(Form)
    DeleteCategoryForm = reduxForm({
        form: 'deleteCategory',
        onSubmit : (values, dispatch) => {
            const {id, isSubcategory, subjectId} = values
            handleDeleteCategory({id, isSubcategory})
                .then((deletedId) => {
                    dispatch(deleteCategoriesEntities({ids : [deletedId], subjectId}))
                    this.handleClose()
                })
        }
    })(Form)

    CreateSourceForm = reduxForm({
        form: 'createSource',
        onSubmit : (values, dispatch) => {
            const {hideForm, name, subjectId, setFocus} = values
            return handleCreateSource({name, subjectId})
                .then(source => {
                    dispatch(changeSourcesEntities({sources : [source], subjectId}))
                    dispatch(reset("createSource"))
                    if (hideForm) this.handleClose()
                    if (setFocus) setFocus()
                })
        }
    })(Form)
    UpdateSourceForm = reduxForm({
        form: 'updateSource',
        onSubmit : (values, dispatch) => {
            const {id, name, subjectId} = values
            return handleUpdateSource({id, name})
                .then(source => {
                    dispatch(changeSourcesEntities({sources : [source], subjectId}))
                    this.handleClose()
                })
        }
    })(Form)
    DeleteSourceForm = reduxForm({
        form: 'deleteSource',
        onSubmit : (values, dispatch) => {
            const {id, subjectId} = values
            handleDeleteSource({id})
                .then((deletedId) => {
                    dispatch(deleteSourcesEntities({ids : [deletedId], subjectId}))
                    this.handleClose()
                })
        }
    })(Form)


    Title = ({children}) => (
        <div className="create-dialog-modal-content__title">{children}</div>
    )
    static contextTypes = {formatMessage: PropTypes.any}
}

export default connect(
    state => ({
        currentSubject : currentSubjectSelector(state),
        currentCategory : currentCursorCategorySelector(state),
        parentCategories : parentCategoriesSelector(state),
        currentSource : currentSourceSelector(state),
        tutorialModeIsOn : tutorialModeSelector(state),
    }),
    dispatch => ({
        hideModal : (...args) => dispatch(hideModal(...args)),
        resetForm : (form) => () => dispatch(reset(form)),
        setCategoryCheckedState : (...args) => dispatch(setCategoryCheckedState(...args)),
        setTutorialMode : (...args) => dispatch(setTutorialMode(...args)),
        handleStep_selectSubjectStep : (...args) => dispatch(handleStep_selectSubjectStep(...args)),
        handleStep_clickMultipleChoice : (...args) => dispatch(handleStep_clickMultipleChoice(...args)),
    })
)(QbmCrudModal)


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmCrudModal/index.js